import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ 
  children, 
  requiredRole, 
  requiredRoles, 
  requiredPermission, 
  permissionLevel = 'RO' 
}) => {
  const { isAuthenticated, hasRole, hasPermission, canAccessApp } = useAuth();

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/no-access" replace />;
  }

  if (requiredRoles && !hasRole(requiredRoles)) {
    return <Navigate to="/no-access" replace />;
  }

  // Check permission-based access
  if (requiredPermission) {
    // First check if user can access the app
    if (!canAccessApp(requiredPermission)) {
      return <Navigate to="/no-access" replace />;
    }

    // Then check if user has the required permission level
    if (!hasPermission(requiredPermission, permissionLevel)) {
      return <Navigate to="/no-access" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
